import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["align", "autoAlign", "className", "children", "definition", "defaultOpen", "id", "openOnHover", "tooltipText", "triggerClassName"];
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import cx from 'classnames';
import React, { useState } from 'react';
import { Popover, PopoverContent } from '../Popover/index.js';
import { Escape } from '../../internal/keyboard/keys.js';
import { match } from '../../internal/keyboard/match.js';
import { useFallbackId } from '../../internal/useId.js';
import { usePrefix } from '../../internal/usePrefix.js';
import { deprecate } from '../../prop-types/deprecate.js';
var DefinitionTooltip = function DefinitionTooltip(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'bottom' : _ref$align,
    autoAlign = _ref.autoAlign,
    className = _ref.className,
    children = _ref.children,
    definition = _ref.definition,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    id = _ref.id,
    openOnHover = _ref.openOnHover,
    tooltipText = _ref.tooltipText,
    triggerClassName = _ref.triggerClassName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var prefix = usePrefix();
  var tooltipId = useFallbackId(id);
  function onKeyDown(event) {
    if (isOpen && match(event, Escape)) {
      event.stopPropagation();
      setOpen(false);
    }
  }
  return /*#__PURE__*/React.createElement(Popover, {
    align: align,
    className: className,
    autoAlign: autoAlign,
    dropShadow: false,
    highContrast: true,
    onMouseLeave: function onMouseLeave() {
      setOpen(false);
    },
    onMouseEnter: function onMouseEnter() {
      openOnHover ? setOpen(true) : null;
    },
    onFocus: function onFocus() {
      setOpen(true);
    },
    open: isOpen
  }, /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: cx("".concat(prefix, "--definition-term"), triggerClassName),
    "aria-controls": tooltipId,
    "aria-describedby": tooltipId,
    "aria-expanded": isOpen,
    onBlur: function onBlur() {
      setOpen(false);
    },
    onMouseDown: function onMouseDown(event) {
      // We use onMouseDown rather than onClick to make sure this triggers
      // before onFocus.
      if (event.button === 0) setOpen(!isOpen);
    },
    onKeyDown: onKeyDown,
    type: "button"
  }), children), /*#__PURE__*/React.createElement(PopoverContent, {
    className: "".concat(prefix, "--definition-tooltip"),
    id: tooltipId
  }, tooltipText !== null && tooltipText !== void 0 ? tooltipText : definition));
};
export { DefinitionTooltip };